// @flow

import React from 'react';
import { Alert, Callout, Intent } from '@blueprintjs/core';
import TagPill from './tag-pill';
import type { TagTypeMeta } from './tag-types';

type TagT = {
  id: string,
  tagType: string,
  tagValue: string,
};

type Props = {
  isOpen: boolean,
  tag: ?TagT,
  usageCount: number,
  tagTypes: TagTypeMeta[],
  loading?: boolean,
  onConfirm: () => mixed,
  onCancel: () => mixed,
};

const DeleteTagAlert = ({
  isOpen,
  tag,
  usageCount,
  tagTypes,
  loading,
  onConfirm,
  onCancel,
}: Props) => {
  const inUse = usageCount > 0;
  return (
    <Alert
      isOpen={isOpen && !!tag}
      cancelButtonText="Cancel"
      confirmButtonText={inUse ? 'Unassign and delete' : 'Delete tag'}
      intent={Intent.DANGER}
      icon="trash"
      loading={loading}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      {tag && (
        <div>
          {!inUse ? (
            <p>
              This tag isn&rsquo;t assigned to any location. You can safely
              delete it.
            </p>
          ) : (
            <>
              <Callout intent={Intent.WARNING} icon="warning-sign" style={{ marginBottom: 12 }}>
                This tag is assigned to {usageCount} location
                {usageCount === 1 ? '' : 's'}.
              </Callout>
              <p>Deleting will:</p>
              <ul>
                <li>
                  Unassign{' '}
                  <span
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    }}
                  >
                    <TagPill tag={tag} tagTypes={tagTypes} />
                  </span>{' '}
                  from {usageCount} location{usageCount === 1 ? '' : 's'}.
                </li>
                <li>Permanently delete the tag.</li>
              </ul>
            </>
          )}
        </div>
      )}
    </Alert>
  );
};

export default DeleteTagAlert;
